module.exports = ".under-construction-wrapper {\n  margin-top: 15%;\n}\nimg {\n  width: 140px;\n  margin-bottom: 20px;\n}\nh2 {\n  margin-top: 15px;\n  font-weight: bolder;\n  margin-bottom: 0;\n  font-size: 36px !important;\n}\nh3 {\n  margin-top: 0px;\n  margin-bottom: 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/under-construction/under-construction.component.css
// module id = ./src/app/feature/main/roles-shared/components/under-construction/under-construction.component.css
// module chunks = main